import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1300 - Tracker Certificate
 *
 * At a Glance: No coupon, shows Upside, Upside participation, Downside, Downside participation, Strike level
 * Barrier: Disabled (no barrier for this product)
 * Underlyings: No barrier level/distance
 * Coupons: Disabled
 * Early Redemption: Disabled
 */
export const config1300: ProductTypeConfig = {
  code: '1300',
  name: 'Tracker Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // No coupon for tracker
        upside: true, // Basket Type up
        upsideParticipation: true, // Participation up %
        downside: true, // Basket type down
        downsideParticipation: true, // Participation down %
        strikeLevel: true, // Strike level
        capLevel: true, // Cap level
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false, // No barrier section for tracker
      props: {
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // No barrier level
        barrierDistance: false, // No barrier distance
      },
    },

    coupons: {
      enabled: false, // No coupons for tracker
      props: {},
    },

    earlyRedemption: {
      enabled: false, // No early redemption for tracker
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },

    couponDetails: {
      enabled: false, // No coupon details for tracker
      props: {},
    },
  },
};
